import Badge from './Badge';

export default {
  id: 'radial_6',
  title: 'Radial_6',
  colors: 3,
  premium: true,
  BadgeComponentStateless: Badge
};
